import React from "react";
import { PageHero, PageCta } from "@/components/PageParts";
import { Contact } from "@/components/Contact";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function ContactPage() {
  usePageMeta(
    "Contact — May Forward Tech",
    "Start a conversation with May Forward Tech. Fully booked for 2026 — accepting 2027 engagements. A senior consultant replies within one business day."
  );
  return (
    <>
      <PageHero
        eyebrow="Contact"
        title="Tell us what you're actually trying to do"
        intro="Not what the software vendor told you to do. A senior consultant — not a sales rep — replies within one business day."
        image="/img/contact-lines.png"
      />
      <div className="-mt-8">
        <Contact />
      </div>
      <PageCta />
    </>
  );
}
